import { get } from 'lodash-es'
import useFetch from './useFetch'

export default function useGetSuburbs(arg) {

  const regionIds = get(arg, 'regionId', get(arg, 'regionIds'))
  const districtIds = get(arg, 'districtId', get(arg, 'districtIds'))
  const suburbIds = get(arg, 'suburbId', get(arg, 'suburbIds'))
  const { data, isLoading } = useFetch(regionIds || districtIds || suburbIds ? { url: 'enum/locations/label', params: { regionIds, districtIds, suburbIds } } : null)

  return {
    data,
    isLoading
  }
}